import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Allocation/Components/Home';
import TableView from './Allocation/Components/TableView';

const RoutesPage = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/results" element={<TableView />} />
            </Routes>
        </>
    )
}

export default RoutesPage